import { Box, Button, Container, Grid, Pagination, Paper, Stack, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import PageProps from "../_types/page-props.interface";
import { StyleHelper } from "../components/style-helper";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { useError } from "../context/error";
import { useEffect, useState } from "react";
import { CallsService } from "../services/calls.service";
import { PastCall } from "../_types/pastcall.type";
import LoadingTable from "../components/loading/table.loading";
import { ArrowRightAltRounded, Info, InfoOutlined } from "@mui/icons-material";




const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0
    }
}))

export default function PastCallsPage(props: PageProps) {
    useDocumentTitle(props.title)

    const { setError } = useError()

    const [loading, setLoading] = useState(true)
    const callsService = new CallsService(setError)
    const [calls, setCalls] = useState<PastCall[]>()
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)

    useEffect(() => {
        _fetchCalls(1)
    }, [])
    const _fetchCalls = async (p: number) => {
        setLoading(true)
        setPage(p)

        const results = await callsService.searchCalls(p)

        if (results?.docs) {
            setCalls(results.docs)
            setTotalPages(results.totalPages)
        }
        setLoading(false)

    }

    return <Container sx={{ display: 'flex', flexDirection: 'column', pb: 4 }}>
        <Grid container>
            <Grid item xs={12} lg={10}>
                <Box display='flex' alignItems='center' gap={2}>
                    <Typography variant='h4'>Past Calls</Typography>
                </Box>
                <StyleHelper.SmallVerticalSpace />
                <Typography variant='body2'> Each week we provide you with a live call hosted by our traders - Dutch & Trader Z. Join us for market analysis, stock chart breakdowns, and live Q&As.</Typography>
            </Grid>

        </Grid>

        <StyleHelper.VerticalSpace />
        {loading && <LoadingTable rowCount={5} columnCount={5} />}
        {!loading && calls && <><TableContainer component={Paper} sx={{ maxHeight: '800px', overflow: 'auto' }}>
            <Table aria-label='wrap table'>
                <TableHead
                    sx={{
                        '& th': {
                            backgroundColor: 'primary.main',
                            color: 'primary.contrastText',
                            position: 'sticky',  // Make the headers sticky
                            top: 0,              // Set it to stick at the top
                            zIndex: 20
                        }
                    }}
                >
                    <TableRow>
                        <TableCell  >Call Date</TableCell>
                        <TableCell></TableCell>
                    </TableRow>

                </TableHead>
                <TableBody>
                    {calls?.map(call => (
                        <StyledTableRow key={call.id}>
                            <TableCell>{new Date(call.date).toLocaleDateString('en-US', { dateStyle: 'full' })}</TableCell>
                            <TableCell>
                                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                    {call.summary &&

                                        <Tooltip title={call.summary}>
                                            <InfoOutlined />
                                        </Tooltip>}

                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => {
                                            window.open(call.recordingLink, '_blank');
                                        }}
                                        endIcon={<ArrowRightAltRounded />}
                                        sx={{ mt: 1, textTransform: 'none', fontWeight: 'bold' }}
                                    >
                                        View
                                    </Button>
                                </Stack>
                            </TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
            <StyleHelper.VerticalSpace />
            <Stack spacing={2} justifyContent='center' alignItems='center'>
                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(event: unknown, page: number) => {
                        _fetchCalls(page)
                    }}
                    variant='outlined'
                    shape='rounded'
                />
            </Stack>
            <StyleHelper.VerticalSpace />

        </>}
    </Container>
}